import React from 'react';

import Step from './step';
import styles from './index.module.css';

const Stepper = () => {
    return (
        <div className={styles.container}>
            <Step
                step={1}
                title="app.request.access.public.landingpage.stepper.step.1.title"
                description="app.request.access.public.landingpage.stepper.step.1.description"
            />
            <Step
                step={2}
                title="app.request.access.public.landingpage.stepper.step.2.title"
                description="app.request.access.public.landingpage.stepper.step.2.description"
            />
            <Step
                step={3}
                title="app.request.access.public.landingpage.stepper.step.3.title"
                description="app.request.access.public.landingpage.stepper.step.3.description"
            />
        </div>
    );
};

export default Stepper;
